import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flame } from 'lucide-react';
// =============================================================================
// PROGRESS RING
// =============================================================================
export function ProgressRing({ done, total, size = 46 }) {
    const percentage = Math.min((done / total) * 100, 100);
    const ringStyle = {
        position: 'relative',
        width: size,
        height: size,
        borderRadius: '50%',
        background: `conic-gradient(
      var(--cc-accent) 0deg ${percentage * 3.6}deg,
      var(--cc-bar) ${percentage * 3.6}deg 360deg
    )`,
    };
    const innerStyle = {
        position: 'absolute',
        inset: 6,
        borderRadius: '50%',
        background: 'var(--cc-elevated)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12.5,
        fontWeight: 800,
        fontFamily: "'JetBrains Mono', monospace",
        color: 'var(--cc-text)',
    };
    return (_jsx("div", { style: ringStyle, children: _jsx("div", { style: innerStyle, children: done }) }));
}
// =============================================================================
// MOMENTUM CARD COMPONENT
// =============================================================================
export function MomentumCard({ dailyDone = 7, dailyTotal = 10, streak = 12, onClick, }) {
    return (_jsxs("div", { onClick: onClick, style: {
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            gap: 14,
            border: '1px solid var(--cc-border)',
            borderRadius: 13,
            padding: '11px 15px',
            background: 'var(--cc-elevated)',
            boxShadow: 'var(--cc-card-shadow)',
            cursor: onClick ? 'pointer' : 'default',
            transition: 'border-color 0.14s ease',
        }, onMouseOver: (e) => {
            if (onClick)
                e.currentTarget.style.borderColor = 'var(--cc-accent)';
        }, onMouseOut: (e) => {
            e.currentTarget.style.borderColor = 'var(--cc-border)';
        }, children: [_jsx(ProgressRing, { done: dailyDone, total: dailyTotal }), _jsxs("div", { children: [_jsx("div", { style: {
                            fontSize: 11,
                            fontWeight: 700,
                            color: 'var(--cc-text-3)',
                            textTransform: 'uppercase',
                            letterSpacing: '0.6px',
                        }, children: "Daily momentum" }), _jsxs("div", { style: {
                            fontSize: 14,
                            fontWeight: 800,
                            marginTop: 2,
                            color: 'var(--cc-text)',
                        }, children: [dailyDone, "/", dailyTotal, " actions"] }), _jsxs("div", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            gap: 5,
                            marginTop: 3,
                            fontSize: 11.5,
                            color: 'var(--cc-accent-strong)',
                            fontWeight: 700,
                        }, children: [_jsx(Flame, { size: 13 }), streak, "-day streak"] })] })] }));
}
// =============================================================================
// COMPACT MOMENTUM (for sidebar/column layout)
// =============================================================================
export function MomentumCardCompact({ dailyDone = 7, dailyTotal = 10, streak = 12, bookedThisWeek = 4, onClick, }) {
    return (_jsx("div", { onClick: onClick, style: {
            border: '1px solid var(--cc-border)',
            borderRadius: 13,
            background: 'var(--cc-elevated)',
            boxShadow: 'var(--cc-card-shadow)',
            padding: '13px 14px',
            cursor: onClick ? 'pointer' : 'default',
            transition: 'border-color 0.14s ease',
        }, onMouseOver: (e) => {
            if (onClick)
                e.currentTarget.style.borderColor = 'var(--cc-accent)';
        }, onMouseOut: (e) => {
            e.currentTarget.style.borderColor = 'var(--cc-border)';
        }, children: _jsxs("div", { style: { display: 'flex', alignItems: 'center', gap: 11 }, children: [_jsx(ProgressRing, { done: dailyDone, total: dailyTotal, size: 42 }), _jsxs("div", { style: { flex: 1 }, children: [_jsxs("div", { style: {
                                fontSize: 13,
                                fontWeight: 800,
                                color: 'var(--cc-text)',
                            }, children: [dailyDone, "/", dailyTotal, " actions today"] }), _jsxs("div", { style: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5,
                                marginTop: 3,
                                fontSize: 11.5,
                                color: 'var(--cc-accent-strong)',
                                fontWeight: 700,
                            }, children: [_jsx(Flame, { size: 13 }), streak, "-day streak \u00B7 ", bookedThisWeek, " booked this week"] })] })] }) }));
}
export default MomentumCard;
